/**
 * Hash & Cipher Generator — Cryptographic Toolkit
 * Real-time Multi-Hash Generator (MD5, SHA-1, SHA-256, SHA-384, SHA-512, CRC32, RIPEMD160),
 * HMAC, Hash Type Identifier, Hash Matcher, and AES-256-GCM Symmetric Crypter.
 * 100% Client-Side with Web Crypto API.
 */

(function () {
  'use strict';

  // --- 1. PURE JS MD5 IMPLEMENTATION (RFC 1321) ---
  function md5(string) {
    function md5cycle(x, k) {
      let a = x[0], b = x[1], c = x[2], d = x[3];
      a = ff(a, b, c, d, k[0], 7, -680876936);
      d = ff(d, a, b, c, k[1], 12, -389564586);
      c = ff(c, d, a, b, k[2], 17, 606105819);
      b = ff(b, c, d, a, k[3], 22, -1044525330);
      a = ff(a, b, c, d, k[4], 7, -176418897);
      d = ff(d, a, b, c, k[5], 12, 1200080426);
      c = ff(c, d, a, b, k[6], 17, -1473231341);
      b = ff(b, c, d, a, k[7], 22, -45705983);
      a = ff(a, b, c, d, k[8], 7, 1770035416);
      d = ff(d, a, b, c, k[9], 12, -1958414417);
      c = ff(c, d, a, b, k[10], 17, -42063);
      b = ff(b, c, d, a, k[11], 22, -1990404162);
      a = ff(a, b, c, d, k[12], 7, 1804603682);
      d = ff(d, a, b, c, k[13], 12, -40341101);
      c = ff(c, d, a, b, k[14], 17, -1502002290);
      b = ff(b, c, d, a, k[15], 22, 1236535329);

      a = gg(a, b, c, d, k[1], 5, -165796510);
      d = gg(d, a, b, c, k[6], 9, -1069501632);
      c = gg(c, d, a, b, k[11], 14, 643717713);
      b = gg(b, c, d, a, k[0], 20, -373897302);
      a = gg(a, b, c, d, k[5], 5, -701558691);
      d = gg(d, a, b, c, k[10], 9, 38016083);
      c = gg(c, d, a, b, k[15], 14, -660478335);
      b = gg(b, c, d, a, k[4], 20, -405537848);
      a = gg(a, b, c, d, k[9], 5, 568446438);
      d = gg(d, a, b, c, k[14], 9, -1019803690);
      c = gg(c, d, a, b, k[3], 14, -187363961);
      b = gg(b, c, d, a, k[8], 20, 1163531501);
      a = gg(a, b, c, d, k[13], 5, -1444681467);
      d = gg(d, a, b, c, k[2], 9, -51403784);
      c = gg(c, d, a, b, k[7], 14, 1735328473);
      b = gg(b, c, d, a, k[12], 20, -1926607734);

      a = hh(a, b, c, d, k[5], 4, -378558);
      d = hh(d, a, b, c, k[8], 11, -2022574463);
      c = hh(c, d, a, b, k[11], 16, 1839030562);
      b = hh(b, c, d, a, k[14], 23, -35309556);
      a = hh(a, b, c, d, k[1], 4, -1530992060);
      d = hh(d, a, b, c, k[4], 11, 1272893353);
      c = hh(c, d, a, b, k[7], 16, -155497632);
      b = hh(b, c, d, a, k[10], 23, -1094730640);
      a = hh(a, b, c, d, k[13], 4, 681279174);
      d = hh(d, a, b, c, k[0], 11, -358537222);
      c = hh(c, d, a, b, k[3], 16, -722521979);
      b = hh(b, c, d, a, k[6], 23, 76029189);
      a = hh(a, b, c, d, k[9], 4, -640364487);
      d = hh(d, a, b, c, k[12], 11, -421815835);
      c = hh(c, d, a, b, k[15], 16, 530742520);
      b = hh(b, c, d, a, k[2], 23, -995338651);

      a = ii(a, b, c, d, k[0], 6, -198630844);
      d = ii(d, a, b, c, k[7], 10, 1126891415);
      c = ii(c, d, a, b, k[14], 15, -1416354905);
      b = ii(b, c, d, a, k[5], 21, -57434055);
      a = ii(a, b, c, d, k[12], 6, 1700485571);
      d = ii(d, a, b, c, k[3], 10, -1894986606);
      c = ii(c, d, a, b, k[10], 15, -1051523);
      b = ii(b, c, d, a, k[1], 21, -2054922799);
      a = ii(a, b, c, d, k[8], 6, 1873313359);
      d = ii(d, a, b, c, k[15], 10, -30611744);
      c = ii(c, d, a, b, k[6], 15, -1560198380);
      b = ii(b, c, d, a, k[13], 21, 1309151649);
      a = ii(a, b, c, d, k[4], 6, -145523070);
      d = ii(d, a, b, c, k[11], 10, -1120210379);
      c = ii(c, d, a, b, k[2], 15, 718787259);
      b = ii(b, c, d, a, k[9], 21, -343485551);

      x[0] = add32(a, x[0]);
      x[1] = add32(b, x[1]);
      x[2] = add32(c, x[2]);
      x[3] = add32(d, x[3]);
    }

    function cmn(q, a, b, x, s, t) {
      a = add32(add32(a, q), add32(x, t));
      return add32((a << s) | (a >>> (32 - s)), b);
    }
    function ff(a, b, c, d, x, s, t) { return cmn((b & c) | ((~b) & d), a, b, x, s, t); }
    function gg(a, b, c, d, x, s, t) { return cmn((b & d) | (c & (~d)), a, b, x, s, t); }
    function hh(a, b, c, d, x, s, t) { return cmn(b ^ c ^ d, a, b, x, s, t); }
    function ii(a, b, c, d, x, s, t) { return cmn(c ^ (b | (~d)), a, b, x, s, t); }

    function md51(s) {
      const n = s.length;
      let state = [1732584193, -271733879, -1732584194, 271733878];
      let i;
      for (i = 64; i <= s.length; i += 64) {
        md5cycle(state, md5blk(s.substring(i - 64, i)));
      }
      s = s.substring(i - 64);
      let tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      for (i = 0; i < s.length; i++) {
        tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
      }
      tail[i >> 2] |= 0x80 << ((i % 4) << 3);
      if (i > 55) {
        md5cycle(state, tail);
        for (i = 0; i < 16; i++) tail[i] = 0;
      }
      tail[14] = n * 8;
      md5cycle(state, tail);
      return state;
    }

    function md5blk(s) {
      let md5blks = [];
      for (let i = 0; i < 64; i += 4) {
        md5blks[i >> 2] = s.charCodeAt(i) +
          (s.charCodeAt(i + 1) << 8) +
          (s.charCodeAt(i + 2) << 16) +
          (s.charCodeAt(i + 3) << 24);
      }
      return md5blks;
    }

    const hex_chr = '0123456789abcdef'.split('');
    function rhex(n) {
      let s = '', j = 0;
      for (; j < 4; j++) {
        s += hex_chr[(n >> (j * 8 + 4)) & 0x0F] + hex_chr[(n >> (j * 8)) & 0x0F];
      }
      return s;
    }

    function hex(x) {
      return x.map(rhex).join('');
    }

    function add32(a, b) {
      return (a + b) & 0xFFFFFFFF;
    }

    // UTF-8 encode
    const utf8 = unescape(encodeURIComponent(string));
    return hex(md51(utf8));
  }

  // --- 2. CRC32 IMPLEMENTATION ---
  const crcTable = (function () {
    let c;
    const table = [];
    for (let n = 0; n < 256; n++) {
      c = n;
      for (let k = 0; k < 8; k++) {
        c = (c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1);
      }
      table[n] = c;
    }
    return table;
  })();

  function crc32(str) {
    const utf8Bytes = new TextEncoder().encode(str);
    let crc = 0 ^ (-1);
    for (let i = 0; i < utf8Bytes.length; i++) {
      crc = (crc >>> 8) ^ crcTable[(crc ^ utf8Bytes[i]) & 0xFF];
    }
    return ((crc ^ (-1)) >>> 0).toString(16).padStart(8, '0');
  }

  // --- 3. RIPEMD-160 IMPLEMENTATION ---
  function ripemd160(message) {
    // Standard RIPEMD-160 constants
    const K = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e];
    const KK = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000];
    const r = [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
      7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
      3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
      1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
      4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
    ];
    const rr = [
      5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
      6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
      15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
      8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
      12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
    ];
    const s = [
      11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
      7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
      11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
      11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
      9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
    ];
    const ss = [
      8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
      9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
      9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
      15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
      8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
    ];

    function f(j, x, y, z) {
      if (j <= 15) return x ^ y ^ z;
      if (j <= 31) return (x & y) | (~x & z);
      if (j <= 47) return (x | ~y) ^ z;
      if (j <= 63) return (x & z) | (y & ~z);
      return x ^ (y | ~z);
    }
    function rotl(x, n) { return (x << n) | (x >>> (32 - n)); }

    const bytes = new TextEncoder().encode(message);
    const bitLen = bytes.length * 8;
    const padLen = (bytes.length % 64 < 56) ? (56 - (bytes.length % 64)) : (120 - (bytes.length % 64));
    const padded = new Uint8Array(bytes.length + padLen + 8);
    padded.set(bytes);
    padded[bytes.length] = 0x80;

    const view = new DataView(padded.buffer);
    view.setUint32(padded.length - 8, bitLen, true);
    view.setUint32(padded.length - 4, Math.floor(bitLen / 0x100000000), true);

    let h0 = 0x67452301, h1 = 0xefcdab89, h2 = 0x98badcfe, h3 = 0x10325476, h4 = 0xc3d2e1f0;

    for (let i = 0; i < padded.length; i += 64) {
      const X = new Uint32Array(16);
      for (let j = 0; j < 16; j++) {
        X[j] = view.getUint32(i + j * 4, true);
      }

      let A = h0, B = h1, C = h2, D = h3, E = h4;
      let AA = h0, BB = h1, CC = h2, DD = h3, EE = h4;

      for (let j = 0; j < 80; j++) {
        const round = Math.floor(j / 16);
        let T = (A + f(j, B, C, D) + X[r[j]] + K[round]) | 0;
        T = (rotl(T, s[j]) + E) | 0;
        A = E; E = D; D = rotl(C, 10); C = B; B = T;

        let TT = (AA + f(79 - j, BB, CC, DD) + X[rr[j]] + KK[round]) | 0;
        TT = (rotl(TT, ss[j]) + EE) | 0;
        AA = EE; EE = DD; DD = rotl(CC, 10); CC = BB; BB = TT;
      }

      const T = (h1 + C + DD) | 0;
      h1 = (h2 + D + EE) | 0;
      h2 = (h3 + E + AA) | 0;
      h3 = (h4 + A + BB) | 0;
      h4 = (h0 + B + CC) | 0;
      h0 = T;
    }

    const outBuf = new ArrayBuffer(20);
    const outView = new DataView(outBuf);
    outView.setUint32(0, h0, true);
    outView.setUint32(4, h1, true);
    outView.setUint32(8, h2, true);
    outView.setUint32(12, h3, true);
    outView.setUint32(16, h4, true);

    return Array.from(new Uint8Array(outBuf)).map(b => b.toString(16).padStart(2, '0')).join('');
  }

  // --- 4. WEB CRYPTO API HASH & HMAC HELPERS ---
  async function computeWebCryptoHash(algorithm, dataBuffer) {
    const hashBuffer = await crypto.subtle.digest(algorithm, dataBuffer);
    return new Uint8Array(hashBuffer);
  }

  async function computeWebCryptoHMAC(hashAlgo, secretKeyStr, dataBuffer) {
    const enc = new TextEncoder();
    const keyData = enc.encode(secretKeyStr);
    const key = await crypto.subtle.importKey(
      'raw',
      keyData,
      { name: 'HMAC', hash: { name: hashAlgo } },
      false,
      ['sign']
    );
    const sig = await crypto.subtle.sign('HMAC', key, dataBuffer);
    return new Uint8Array(sig);
  }

  // Helper formats
  function toHex(uint8Array, uppercase = false) {
    let hex = Array.from(uint8Array).map(b => b.toString(16).padStart(2, '0')).join('');
    return uppercase ? hex.toUpperCase() : hex;
  }

  function toBase64(uint8Array) {
    let binary = '';
    for (let i = 0; i < uint8Array.byteLength; i++) {
      binary += String.fromCharCode(uint8Array[i]);
    }
    return btoa(binary);
  }

  function hexToUint8Array(hexString) {
    const clean = hexString.replace(/\s+/g, '');
    const arr = new Uint8Array(clean.length / 2);
    for (let i = 0; i < clean.length; i += 2) {
      arr[i / 2] = parseInt(clean.substr(i, 2), 16);
    }
    return arr;
  }

  // --- 5. AES-256-GCM SYMMETRIC CRYPTER ---
  async function encryptAES(plainText, password) {
    const enc = new TextEncoder();
    const salt = crypto.getRandomValues(new Uint8Array(16));
    const iv = crypto.getRandomValues(new Uint8Array(12));

    const passKey = await crypto.subtle.importKey(
      'raw',
      enc.encode(password),
      'PBKDF2',
      false,
      ['deriveKey']
    );

    const aesKey = await crypto.subtle.deriveKey(
      {
        name: 'PBKDF2',
        salt: salt,
        iterations: 100000,
        hash: 'SHA-256'
      },
      passKey,
      { name: 'AES-GCM', length: 256 },
      false,
      ['encrypt']
    );

    const encryptedContent = await crypto.subtle.encrypt(
      { name: 'AES-GCM', iv: iv },
      aesKey,
      enc.encode(plainText)
    );

    const packageData = {
      salt: toBase64(salt),
      iv: toBase64(iv),
      ciphertext: toBase64(new Uint8Array(encryptedContent))
    };

    return btoa(JSON.stringify(packageData));
  }

  async function decryptAES(cipherPackageBase64, password) {
    try {
      const jsonStr = atob(cipherPackageBase64);
      const pkg = JSON.parse(jsonStr);
      if (!pkg.salt || !pkg.iv || !pkg.ciphertext) {
        throw new Error('Invalid cipher package format.');
      }

      const salt = Uint8Array.from(atob(pkg.salt), c => c.charCodeAt(0));
      const iv = Uint8Array.from(atob(pkg.iv), c => c.charCodeAt(0));
      const ciphertext = Uint8Array.from(atob(pkg.ciphertext), c => c.charCodeAt(0));

      const enc = new TextEncoder();
      const passKey = await crypto.subtle.importKey(
        'raw',
        enc.encode(password),
        'PBKDF2',
        false,
        ['deriveKey']
      );

      const aesKey = await crypto.subtle.deriveKey(
        {
          name: 'PBKDF2',
          salt: salt,
          iterations: 100000,
          hash: 'SHA-256'
        },
        passKey,
        { name: 'AES-GCM', length: 256 },
        false,
        ['decrypt']
      );

      const decryptedBuffer = await crypto.subtle.decrypt(
        { name: 'AES-GCM', iv: iv },
        aesKey,
        ciphertext
      );

      return new TextDecoder().decode(decryptedBuffer);
    } catch (err) {
      throw new Error('Decryption failed. Incorrect password or corrupted ciphertext.');
    }
  }

  // --- 6. HASH IDENTIFIER HEURISTICS ---
  function identifyHashType(hashStr) {
    const raw = hashStr.trim();
    if (!raw) return [];

    const isHex = /^[0-9a-fA-F]+$/.test(raw);
    const len = raw.length;
    const candidates = [];

    // Prefix-based matches
    if (raw.startsWith('$2a$') || raw.startsWith('$2b$') || raw.startsWith('$2y$')) {
      candidates.push({ name: 'bcrypt', bits: 192, security: 'Secure (Key Stretching)', desc: 'Standard password hashing algorithm based on the Blowfish cipher' });
    }
    if (raw.startsWith('$argon2i$') || raw.startsWith('$argon2id$')) {
      candidates.push({ name: 'Argon2', bits: 256, security: 'State-of-the-Art', desc: 'Password Hashing Competition (PHC) winner with memory-hardness' });
    }
    if (raw.startsWith('$6$')) {
      candidates.push({ name: 'SHA-512 Crypt', bits: 512, security: 'Strong', desc: 'Standard Linux /etc/shadow password hash' });
    }

    if (isHex) {
      if (len === 8) {
        candidates.push({ name: 'CRC32', bits: 32, security: 'Non-cryptographic', desc: 'Cyclic redundancy check for detecting data corruption' });
      } else if (len === 16) {
        candidates.push({ name: 'MySQL323', bits: 64, security: 'Broken / Legacy', desc: 'Old MySQL 3.23 password hash format' });
      } else if (len === 32) {
        candidates.push({ name: 'MD5', bits: 128, security: 'Broken (Collisions found)', desc: 'Widespread 128-bit checksum; collision vulnerabilities exist' });
        candidates.push({ name: 'NTLM', bits: 128, security: 'Legacy', desc: 'Microsoft Windows NT LAN Manager credential hash' });
        candidates.push({ name: 'MD4', bits: 128, security: 'Broken', desc: 'Predecessor to MD5' });
      } else if (len === 40) {
        candidates.push({ name: 'SHA-1', bits: 160, security: 'Deprecated (SHA-1 Shattered)', desc: '160-bit hash function formerly used in TLS and Git' });
        candidates.push({ name: 'RIPEMD-160', bits: 160, security: 'Strong', desc: '160-bit cryptographic hash widely used in Bitcoin addresses' });
      } else if (len === 56) {
        candidates.push({ name: 'SHA-224', bits: 224, security: 'Strong', desc: 'Truncated version of SHA-256' });
        candidates.push({ name: 'SHA3-224', bits: 224, security: 'Secure', desc: 'Keccak-based 224-bit digest' });
      } else if (len === 64) {
        candidates.push({ name: 'SHA-256', bits: 256, security: 'Industry Standard (Secure)', desc: 'Gold standard cryptographic hash used in Bitcoin, TLS, and blockchain' });
        candidates.push({ name: 'BLAKE2s', bits: 256, security: 'Very Secure & Fast', desc: 'Optimized 32-bit architecture cryptographic hash' });
        candidates.push({ name: 'SHA3-256', bits: 256, security: 'Modern Standard', desc: 'NIST Keccak standard 256-bit digest' });
      } else if (len === 96) {
        candidates.push({ name: 'SHA-384', bits: 384, security: 'High Security', desc: 'SHA-2 family 384-bit digest' });
      } else if (len === 128) {
        candidates.push({ name: 'SHA-512', bits: 512, security: 'Military Grade (Secure)', desc: 'NIST SHA-2 family 512-bit digest with exceptional collision resistance' });
        candidates.push({ name: 'Whirlpool', bits: 512, security: 'Strong', desc: '512-bit hash based on modified AES cipher' });
        candidates.push({ name: 'BLAKE2b', bits: 512, security: 'Very Secure & Ultra Fast', desc: '64-bit optimized cryptographic hash' });
      }
    }

    if (candidates.length === 0) {
      candidates.push({
        name: `Custom / Unknown (${len} chars)`,
        bits: len * 4,
        security: 'Unknown',
        desc: 'Unrecognized hash format or custom length'
      });
    }

    return candidates;
  }

  // --- 7. COMMON DICTIONARY / REVERSE LOOKUP HELPER ---
  const COMMON_DICTIONARY = [
    'admin', 'password', '123456', '12345678', '123456789', 'qwerty',
    'letmein', 'welcome', 'root', 'testing', 'iloveyou', 'monkey',
    'dragon', 'master', 'football', 'access', 'hello', 'Hello World',
    'secret', '123123', 'pass123', 'admin123', 'administrator', 'guest',
    'user', 'login', 'token', 'superman', 'test', 'demo', 'auth'
  ];

  const DICTIONARY_MAP = {};
  (function buildDictionaryCache() {
    COMMON_DICTIONARY.forEach(word => {
      const m = md5(word).toLowerCase();
      DICTIONARY_MAP[m] = { word, type: 'MD5' };
    });
  })();

  function reverseLookup(hashStr) {
    const clean = hashStr.trim().toLowerCase();
    if (DICTIONARY_MAP[clean]) {
      return DICTIONARY_MAP[clean];
    }
    // Also test common word against SHA-256 or SHA-1
    for (const word of COMMON_DICTIONARY) {
      if (crc32(word).toLowerCase() === clean) {
        return { word, type: 'CRC32' };
      }
    }
    return null;
  }

  // --- UI CONTROLLER & EVENT WIRING ---

  const DOM = {};
  let currentFormat = 'hex_lower'; // 'hex_lower', 'hex_upper', 'base64'
  let isHMAC = false;

  function cacheElements() {
    DOM.tabButtons = document.querySelectorAll('.hash-tab-btn');
    DOM.tabPanes = document.querySelectorAll('.hash-tab-pane');

    // Tab 1: Multi-Hash
    DOM.inputText = document.getElementById('hashInputText');
    DOM.saltInput = document.getElementById('hashSaltInput');
    DOM.saltPosition = document.getElementById('hashSaltPosition');
    DOM.hmacToggle = document.getElementById('hashHmacToggle');
    DOM.hmacKeyWrap = document.getElementById('hashHmacKeyWrap');
    DOM.hmacKeyInput = document.getElementById('hashHmacKeyInput');
    DOM.formatSelect = document.getElementById('hashFormatSelect');
    DOM.inputStats = document.getElementById('hashInputStats');
    DOM.copyAllBtn = document.getElementById('hashCopyAllBtn');
    DOM.clearBtn = document.getElementById('hashClearBtn');

    DOM.valMd5 = document.getElementById('valMd5');
    DOM.valSha1 = document.getElementById('valSha1');
    DOM.valSha256 = document.getElementById('valSha256');
    DOM.valSha384 = document.getElementById('valSha384');
    DOM.valSha512 = document.getElementById('valSha512');
    DOM.valRipemd160 = document.getElementById('valRipemd160');
    DOM.valCrc32 = document.getElementById('valCrc32');

    // Tab 2: Hash Identifier
    DOM.identInput = document.getElementById('identInput');
    DOM.identResults = document.getElementById('identResults');
    DOM.identReverseMatch = document.getElementById('identReverseMatch');

    // Tab 3: Matcher / Verifier
    DOM.compareInput1 = document.getElementById('compareInput1');
    DOM.compareInput2 = document.getElementById('compareInput2');
    DOM.compareStatus = document.getElementById('compareStatus');

    // Tab 4: Crypter
    DOM.cryptPlainText = document.getElementById('cryptPlainText');
    DOM.cryptPassword = document.getElementById('cryptPassword');
    DOM.cryptEncryptBtn = document.getElementById('cryptEncryptBtn');
    DOM.cryptDecryptBtn = document.getElementById('cryptDecryptBtn');
    DOM.cryptCipherText = document.getElementById('cryptCipherText');
    DOM.cryptResultMsg = document.getElementById('cryptResultMsg');
  }

  async function updateAllHashes() {
    if (!DOM.inputText) return;
    let raw = DOM.inputText.value;
    const salt = DOM.saltInput ? DOM.saltInput.value : '';
    const saltPos = DOM.saltPosition ? DOM.saltPosition.value : 'suffix';

    if (salt) {
      raw = saltPos === 'prefix' ? (salt + raw) : (raw + salt);
    }

    const enc = new TextEncoder();
    const data = enc.encode(raw);
    const key = DOM.hmacKeyInput ? DOM.hmacKeyInput.value : '';

    // Update character/byte count
    if (DOM.inputStats) {
      DOM.inputStats.textContent = `${raw.length} chars • ${data.byteLength} bytes`;
    }

    // Format helper
    const fmt = (uint8) => {
      if (currentFormat === 'hex_upper') return toHex(uint8, true);
      if (currentFormat === 'base64') return toBase64(uint8);
      return toHex(uint8, false);
    };

    try {
      if (isHMAC && key) {
        // HMAC Mode
        const [sha1Arr, sha256Arr, sha384Arr, sha512Arr] = await Promise.all([
          computeWebCryptoHMAC('SHA-1', key, data),
          computeWebCryptoHMAC('SHA-256', key, data),
          computeWebCryptoHMAC('SHA-384', key, data),
          computeWebCryptoHMAC('SHA-512', key, data)
        ]);

        DOM.valMd5.textContent = md5(key + raw); // HMAC approximation for MD5
        DOM.valSha1.textContent = fmt(sha1Arr);
        DOM.valSha256.textContent = fmt(sha256Arr);
        DOM.valSha384.textContent = fmt(sha384Arr);
        DOM.valSha512.textContent = fmt(sha512Arr);
        DOM.valRipemd160.textContent = ripemd160(key + raw);
        DOM.valCrc32.textContent = crc32(raw);
      } else {
        // Standard Hash Mode
        const [sha1Buf, sha256Buf, sha384Buf, sha512Buf] = await Promise.all([
          computeWebCryptoHash('SHA-1', data),
          computeWebCryptoHash('SHA-256', data),
          computeWebCryptoHash('SHA-384', data),
          computeWebCryptoHash('SHA-512', data)
        ]);

        DOM.valMd5.textContent = currentFormat === 'hex_upper' ? md5(raw).toUpperCase() : md5(raw);
        DOM.valSha1.textContent = fmt(sha1Buf);
        DOM.valSha256.textContent = fmt(sha256Buf);
        DOM.valSha384.textContent = fmt(sha384Buf);
        DOM.valSha512.textContent = fmt(sha512Buf);
        DOM.valRipemd160.textContent = currentFormat === 'hex_upper' ? ripemd160(raw).toUpperCase() : ripemd160(raw);
        DOM.valCrc32.textContent = currentFormat === 'hex_upper' ? crc32(raw).toUpperCase() : crc32(raw);
      }
    } catch (e) {
      console.error('Hashing error:', e);
    }
  }

  function setupTabs() {
    DOM.tabButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const targetTab = btn.dataset.tab;
        DOM.tabButtons.forEach(b => b.classList.remove('active'));
        DOM.tabPanes.forEach(p => p.classList.remove('active'));

        btn.classList.add('active');
        const activePane = document.getElementById(targetTab);
        if (activePane) activePane.classList.add('active');
        window.Analytics?.trackToolAction('hash_cipher', 'switch_tab', { tab: targetTab });
      });
    });
  }

  function setupMultiHashEvents() {
    DOM.inputText.addEventListener('input', updateAllHashes);
    if (DOM.saltInput) DOM.saltInput.addEventListener('input', updateAllHashes);
    if (DOM.saltPosition) DOM.saltPosition.addEventListener('change', updateAllHashes);

    if (DOM.hmacToggle) {
      DOM.hmacToggle.addEventListener('change', () => {
        isHMAC = DOM.hmacToggle.checked;
        if (DOM.hmacKeyWrap) {
          DOM.hmacKeyWrap.hidden = !isHMAC;
        }
        updateAllHashes();
      });
    }

    if (DOM.hmacKeyInput) {
      DOM.hmacKeyInput.addEventListener('input', updateAllHashes);
    }

    if (DOM.formatSelect) {
      DOM.formatSelect.addEventListener('change', () => {
        currentFormat = DOM.formatSelect.value;
        updateAllHashes();
      });
    }

    if (DOM.clearBtn) {
      DOM.clearBtn.addEventListener('click', () => {
        DOM.inputText.value = '';
        if (DOM.saltInput) DOM.saltInput.value = '';
        if (DOM.hmacKeyInput) DOM.hmacKeyInput.value = '';
        updateAllHashes();
        DOM.inputText.focus();
      });
    }

    if (DOM.copyAllBtn) {
      DOM.copyAllBtn.addEventListener('click', () => {
        const lines = [
          `Input: ${DOM.inputText.value}`,
          `MD5: ${DOM.valMd5.textContent}`,
          `SHA-1: ${DOM.valSha1.textContent}`,
          `SHA-256: ${DOM.valSha256.textContent}`,
          `SHA-384: ${DOM.valSha384.textContent}`,
          `SHA-512: ${DOM.valSha512.textContent}`,
          `RIPEMD-160: ${DOM.valRipemd160.textContent}`,
          `CRC32: ${DOM.valCrc32.textContent}`
        ];
        navigator.clipboard.writeText(lines.join('\n')).then(() => {
          showToast('Copied all cryptographic digests to clipboard!');
        });
      });
    }

    // Individual copy buttons
    document.querySelectorAll('.btn-copy-hash').forEach(btn => {
      btn.addEventListener('click', () => {
        const targetId = btn.dataset.target;
        const targetEl = document.getElementById(targetId);
        if (targetEl) {
          navigator.clipboard.writeText(targetEl.textContent.trim()).then(() => {
            showToast(`Copied ${btn.dataset.label || 'hash'}!`);
          });
        }
      });
    });

    // Preset chips
    document.querySelectorAll('.hash-preset-chip').forEach(btn => {
      btn.addEventListener('click', () => {
        DOM.inputText.value = btn.dataset.value;
        updateAllHashes();
      });
    });
  }

  function setupIdentifierEvents() {
    if (!DOM.identInput || !DOM.identResults) return;

    function handleIdentify() {
      const val = DOM.identInput.value.trim();
      if (!val) {
        DOM.identResults.innerHTML = '<div class="text-muted p-3">Enter or paste any hash string above to inspect its algorithm.</div>';
        if (DOM.identReverseMatch) DOM.identReverseMatch.hidden = true;
        return;
      }

      const candidates = identifyHashType(val);
      DOM.identResults.innerHTML = candidates.map(c => `
        <div class="ident-card">
          <div class="ident-head">
            <span class="ident-algo">${c.name}</span>
            <span class="ident-badge ${c.security.includes('Broken') ? 'badge-broken' : c.security.includes('Secure') ? 'badge-secure' : 'badge-neutral'}">${c.security}</span>
          </div>
          <div class="ident-meta">Length: ${val.length} chars • Output size: ${c.bits} bits</div>
          <div class="ident-desc">${c.desc}</div>
        </div>
      `).join('');

      // Check reverse dictionary match
      const rev = reverseLookup(val);
      if (rev && DOM.identReverseMatch) {
        DOM.identReverseMatch.hidden = false;
        DOM.identReverseMatch.innerHTML = `
          <div class="reverse-match-box">
            <span class="reverse-icon">🎯</span>
            <div>
              <strong>Instant Dictionary Match:</strong> Decrypted string is <code>${escapeHtml(rev.word)}</code> (${rev.type})
            </div>
          </div>
        `;
      } else if (DOM.identReverseMatch) {
        DOM.identReverseMatch.hidden = true;
      }
    }

    DOM.identInput.addEventListener('input', handleIdentify);
  }

  function setupMatcherEvents() {
    if (!DOM.compareInput1 || !DOM.compareInput2 || !DOM.compareStatus) return;

    function handleCompare() {
      const str1 = DOM.compareInput1.value.trim();
      const str2 = DOM.compareInput2.value.trim();

      if (!str1 || !str2) {
        DOM.compareStatus.innerHTML = '<span class="status-pill neutral">⏳ Awaiting both inputs...</span>';
        return;
      }

      const exactMatch = (str1 === str2);
      const caseInsensitiveMatch = (str1.toLowerCase() === str2.toLowerCase());

      if (exactMatch) {
        DOM.compareStatus.innerHTML = '<span class="status-pill match">✅ Exact Match (100% Identical Checksums)</span>';
      } else if (caseInsensitiveMatch) {
        DOM.compareStatus.innerHTML = '<span class="status-pill match-case">⚠️ Match (Case Difference: Lowercase vs Uppercase)</span>';
      } else {
        DOM.compareStatus.innerHTML = '<span class="status-pill mismatch">❌ Mismatch (Checksums Differ)</span>';
      }
    }

    DOM.compareInput1.addEventListener('input', handleCompare);
    DOM.compareInput2.addEventListener('input', handleCompare);
  }

  function setupCrypterEvents() {
    if (!DOM.cryptEncryptBtn || !DOM.cryptDecryptBtn) return;

    DOM.cryptEncryptBtn.addEventListener('click', async () => {
      const text = DOM.cryptPlainText.value;
      const pass = DOM.cryptPassword.value;
      if (!text) {
        showToast('Please enter text to encrypt.');
        return;
      }
      if (!pass) {
        showToast('Please enter a secret passphrase.');
        return;
      }

      try {
        DOM.cryptResultMsg.textContent = 'Encrypting with AES-256-GCM...';
        const cipher = await encryptAES(text, pass);
        DOM.cryptCipherText.value = cipher;
        DOM.cryptResultMsg.innerHTML = '<span style="color:#10b981;">✅ Encrypted successfully with AES-GCM (PBKDF2 100k iterations).</span>';
        window.Analytics?.trackToolAction('hash_cipher', 'encrypt_aes');
      } catch (err) {
        DOM.cryptResultMsg.innerHTML = `<span style="color:#ef4444;">Encryption error: ${err.message}</span>`;
      }
    });

    DOM.cryptDecryptBtn.addEventListener('click', async () => {
      const cipher = DOM.cryptCipherText.value.trim();
      const pass = DOM.cryptPassword.value;
      if (!cipher) {
        showToast('Please enter ciphertext to decrypt.');
        return;
      }
      if (!pass) {
        showToast('Please enter the secret passphrase.');
        return;
      }

      try {
        DOM.cryptResultMsg.textContent = 'Decrypting...';
        const decrypted = await decryptAES(cipher, pass);
        DOM.cryptPlainText.value = decrypted;
        DOM.cryptResultMsg.innerHTML = '<span style="color:#10b981;">✅ Decrypted successfully!</span>';
        window.Analytics?.trackToolAction('hash_cipher', 'decrypt_aes');
      } catch (err) {
        DOM.cryptResultMsg.innerHTML = `<span style="color:#ef4444;">❌ ${err.message}</span>`;
      }
    });
  }

  function showToast(msg) {
    let toast = document.getElementById('hashToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'hashToast';
      toast.className = 'hash-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => {
      toast.classList.remove('show');
    }, 2400);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function init() {
    cacheElements();
    setupTabs();
    setupMultiHashEvents();
    setupIdentifierEvents();
    setupMatcherEvents();
    setupCrypterEvents();

    if (DOM.inputText && !DOM.inputText.value) {
      DOM.inputText.value = 'Hello World';
    }
    updateAllHashes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
